import Modal from 'bootstrap/js/src/modal';

class UnsubscribeFormController {
    /*@ngInject*/
    constructor($log) {
        $log.debug('UnsubscribeFormController initialized');
        this.requestPending = false;
        this.modalUnsubscribe = $('#modal-unsubscribe');
        if (this.modalUnsubscribe.length) {
            new Modal(this.modalUnsubscribe[0], {
                show: false
            });
        }
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }

    requestSubmit () {
        this.modalUnsubscribe.modal('show');
    }
}

export default UnsubscribeFormController;
